import { AllocationChartItemData } from "@client/components/round/allocator/AllocationChart/AllocationChart";
import { RoundAggregate } from "@engine/round/aggregate";
import { roundIsReadyToEvaluate } from "@engine/round/consistencyCheck";
import {
  runSProcessOnRound,
  type SProcessOutput,
} from "@lib/algoInterface/runSProcessOnRound";
import { Evaluable } from "@lib/types";

export function calculateSProcessResults(round: RoundAggregate): {
  allocations: AllocationChartItemData[] | null;
  results: SProcessOutput | Error | null;
  readyStatus: { isReady: boolean; reasonsWhyNot: string[] };
} {
  const readyStatus = roundIsReadyToEvaluate(round);

  if (!readyStatus.isReady) {
    return {
      allocations: null,
      results: null,
      readyStatus,
    };
  }

  let results: SProcessOutput | Error;
  try {
    results = runSProcessOnRound(round);
  } catch (e) {
    return {
      allocations: null,
      results: e as Error,
      readyStatus,
    };
  }

  const lastLayerIndex = results.layerTargetTotals.length - 1;
  const allocations: AllocationChartItemData[] = [];

  // Skip the hold node for now
  for (let i = 1; i < results.layerTargetTotals[lastLayerIndex].length; i++) {
    const allocation = results.layerTargetTotals[lastLayerIndex].get(i);
    if (allocation === 0) continue;

    allocations.push({
      evaluableId: (results.layerNodes[lastLayerIndex][i] as Evaluable).id,
      allocation,
    });
  }

  // Final hold value is the total of all hold nodes
  const holdTotal = results.layerTargetTotals.reduce(
    (sum, layer) => sum + layer.get(0),
    0,
  );

  allocations.push({
    evaluableId: (results.layerNodes[lastLayerIndex][0] as Evaluable).id,
    allocation: holdTotal,
  });

  return { allocations, results, readyStatus };
}
